export { default } from './RecentJobsCard';



// WEBPACK FOOTER //
// ./vendor/ruby/2.7.0/gems/foreman_remote_execution-10.1.1/webpack/react_app/components/RecentJobsCard/index.js